<template>
  <div id="pdf-template-boxes-table">
    <span style="font-size:24px;bold">{{$t('pdf_template_texts_table.boxes')}}</span>
    <table cellpadding="0" cellspacing="0">
      <tr class="header-row" v-if="template.boxes.length > 0">
        <td
          v-for="(header, i) in headers"
          :key="i"
          :style="{ 'width': header.width + '%'}"
        >{{header.text}}</td>
      </tr>
      <tr v-for="(box, i) in template.boxes" :key="i">
        <td>
          <input v-model="box.x1" type="number" @keydown="joystick($event, box, ['x1', 'y1'])" />
        </td>
        <td>
          <input v-model="box.y1" type="number" @keydown="joystick($event, box, ['x1', 'y1'])" />
        </td>
        <td>
          <input v-model="box.width" type="number" @keydown="joystick($event, box, ['width', 'height'])" />
        </td>
        <td>
          <input v-model="box.height" type="number" @keydown="joystick($event, box, ['width', 'height'])"/>
        </td>
        <td>
          <v-icon small @click="deleteBox(i)">delete</v-icon>
        </td>
      </tr>
    </table>
    <button
      type="submit"
      class="btn btn-primary"
      @click="addBox"
    >{{$t('pdf_template_texts_table.add_box')}}</button>
  </div>
</template>

<script>
import PdfTemplateBox from "@/models/PdfTemplateBox.js";
import Helper from "@/models/Helper.js";
export default {
  name: "pdf-template-boxes-table",
  props: {
    template: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      headers: [
        {
          text: "X",
          width: 20,
        },
        {
          text: "Y",
          width: 20,
        },
        {
          text: this.$t("pdf_template_texts_table.width"),
          width: 20,
        },
        {
          text: this.$t("pdf_template_texts_table.height"),
          width: 20,
        },
        {
          text: this.$t("pdf_template_texts_table.actions"),
          with: 20,
        },
      ],
      defaultBox: {
        x1: 0,
        y1: 0,
        width: 50,
        height: 50,
      },
    };
  },
  methods: {
    addBox() {
      this.template.boxes.push(new PdfTemplateBox(this.defaultBox));
    },
    deleteBox(i) {
      this.template.boxes.splice(i, 1);
    },
    joystick(e, box, props) {
      Helper.joystick(e, box, props);
    },
  },
};
</script>

<style scoped>
input {
  border: 0px solid #000;
  margin: 0;
  background: transparent;
  width: 100%;
}
table tr td {
  border-right: 1px solid #000;
  border-bottom: 1px solid #000;
}
table {
  background: #fff none repeat scroll 0 0;
  border-left: 1px solid #000;
  border-top: 1px solid #000;
}
table tr:nth-child(even) {
  background: #ccc;
}
table tr:nth-child(odd) {
  background: #eee;
}
.header-row {
  font-weight: bold;
}
</style>